var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 11.25C10.6667 10.4359 10.6667 10.0289 10.5662 9.69766C10.34 8.95193 9.75644 8.36835 9.01071 8.14214C8.67949 8.04166 8.27245 8.04166 7.45837 8.04166H4.54171C3.72763 8.04166 3.32059 8.04166 2.98937 8.14214C2.24364 8.36835 1.66006 8.95193 1.43385 9.69766C1.33337 10.0289 1.33337 10.4359 1.33337 11.25M8.62504 3.375C8.62504 4.82475 7.44979 6 6.00004 6C4.55029 6 3.37504 4.82475 3.37504 3.375C3.37504 1.92525 4.55029 0.75 6.00004 0.75C7.44979 0.75 8.62504 1.92525 8.62504 3.375Z",
    stroke: "#70767B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.bec044f2bc79426a43f8f930a264539c.svg";
export { ForwardRef as ReactComponent };